export const environment = {
    url: "https://api-tbm.policystreet.app/api",
};
